"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import React, { useEffect } from "react";
import { Messages, readMessages } from "./Messages";
export function PageTransitionWrapper(param) {
    var children = param.children;
    return /*#__PURE__*/ React.createElement("main", null, useReducedMotion() ? /*#__PURE__*/ React.createElement(React.Fragment, null, children) : /*#__PURE__*/ React.createElement(AnimatePresence, {
        mode: "wait",
        initial: false
    }, children));
}
export function PageTransition(param) {
    var children = param.children;
    var _React_useState = _sliced_to_array(React.useState([]), 2), messages = _React_useState[0], setMessages = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState([]), 2), messageComponents = _React_useState1[0], setMessageComponents = _React_useState1[1];
    useEffect(function() {
        // Standard messages.
        setMessages(readMessages());
        // Language message.
        var languageMessage = getLanguageMessage(window.location.href);
        if (languageMessage) {
            setMessageComponents([
                languageMessage
            ]);
        }
    }, []);
    return useReducedMotion() ? /*#__PURE__*/ React.createElement("main", {
        id: "main-content"
    }, /*#__PURE__*/ React.createElement(Messages, {
        messages: messages,
        messageComponents: messageComponents
    }), children) : /*#__PURE__*/ React.createElement(motion.main, {
        id: "main-content",
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        exit: {
            opacity: 0
        },
        transition: {
            type: "spring",
            mass: 0.35,
            stiffness: 75,
            duration: 0.3
        }
    }, /*#__PURE__*/ React.createElement(Messages, {
        messages: messages,
        messageComponents: messageComponents
    }), children);
}
function getLanguageMessage(url) {
    var urlObject = new URL(url);
    var contentLanguageNotAvailable = urlObject.searchParams.get("content_language_not_available") === "true";
    if (contentLanguageNotAvailable) {
        var requestedLanguage = urlObject.searchParams.get("requested_language");
        if (requestedLanguage) {
            var translations = {
                en: {
                    message: "This page is not available in the requested language.",
                    goBack: "Go back"
                },
                de: {
                    message: "Diese Seite ist nicht in der angeforderten Sprache verf\xfcgbar.",
                    goBack: "Zur\xfcck"
                },
                fr: {
                    message: "Cette page n'est pas disponible dans la langue demand\xe9e.",
                    goBack: "Retour"
                },
                it: {
                    message: "Questa pagina non \xe8 disponibile nella lingua richiesta.",
                    goBack: "Torna indietro"
                }
            };
            var translation = translations[requestedLanguage];
            if (translation) {
                return /*#__PURE__*/ React.createElement("div", null, translation.message, " ", /*#__PURE__*/ React.createElement("a", {
                    href: "#",
                    onClick: function() {
                        window.history.back();
                    }
                }, translation.goBack));
            } else {
                console.error('Requested language "'.concat(requestedLanguage, '" not found in messages.'));
            }
        }
    }
}
